import Splide from "@splidejs/splide";
import GLightbox from "glightbox";

import isTouch from "./utils/is-touch";
import ready from "./utils/document-ready";

import SearchBar from "./components/search-bar";
import SettingsBar from "./components/settings-bar";

let mobileMenuCloseCallbacks = [];
let mobileMenuCloseFire = () => {
  mobileMenuCloseCallbacks.forEach((callback) => {
    callback();
  });
};

ready(() => {
  // Add body class on touch
  if (isTouch) {
    document.body.classList.add("touch");
  }

  // Mobile menu classes
  [...document.querySelectorAll(".js-mobile-menu")].forEach((menu) => {
    const menuButtons = [...menu.querySelectorAll(".js-mobile-menu__button")];

    menuButtons.forEach((button) => {
      button.addEventListener("click", () => {
        menu.classList.toggle("open");
        document.body.classList.toggle("mobile-menu-open");
        mobileMenuCloseFire();
      });
    });
  });

  const searchBars = SearchBar.bindDOM();
  const settingsBars = SettingsBar.bindDOM();

  mobileMenuCloseCallbacks.push(() => {
    searchBars.forEach((searchBar) => searchBar.close());
    settingsBars.forEach((settingsBar) => settingsBar.close());
  });

  // Splide
  let mainSlider = document.getElementById("main-slider");
  let videoElement = null;

  if (mainSlider) {
    let mainSplide = new Splide("#main-slider", {
      type: "loop",
      autoplay: true,
      lazyLoad: "nearby",
      type: "fade",
      rewind: true,
      height: "490px",
      cover: true,
      pagination: false,
      breakpoints: {
        1220: {
          height: "410px",
        },
        768: {
          height: "300px",
        },
      },
    }).mount();

    const stopPlaying = () => {
      if (videoElement) {
        let tempVideoElement = videoElement;
        let tempParentNode = videoElement.parentNode;

        videoElement = null;
        mainSplide.options = { autoplay: true };
        tempVideoElement.parentNode.classList.remove("playing");
        tempVideoElement.pause();
        setTimeout(() => {
          tempParentNode.removeChild(tempVideoElement);
        }, 500);
      }
    };

    mainSlider
      .querySelectorAll(".js-main-slider-play")
      .forEach((playButton) => {
        playButton.addEventListener("click", () => {
          mainSplide.options = { autoplay: false };

          videoElement = document.createElement("video");
          videoElement.setAttribute("controls", true);
          videoElement.setAttribute("src", playButton.getAttribute("data-src"));
          videoElement.classList.add("main-slider__video");
          playButton.parentNode.insertBefore(videoElement, playButton);

          videoElement.play();
          playButton.parentNode.classList.add("playing");

          videoElement.addEventListener("ended", stopPlaying);
        });
      });

    mainSplide.on("move", stopPlaying);
  }

  if (document.querySelector("#partners-slider")) {
    new Splide("#partners-slider", {
      type: "loop",
      autoplay: true,
      focus: "center",
      perPage: 7,
      perMove: 1,
      autoWidth: true,
      height: "60px",
      pagination: false,
      arrows: false,
      breakpoints: {
        1440: {
          perPage: 7,
          gap: "1rem",
        },
        1220: {
          perPage: 6,
          gap: "1rem",
        },
        1024: {
          perPage: 5,
          gap: "1rem",
        },
        640: {
          perPage: 4,
          gap: "1rem",
        },
        480: {
          perPage: 3,
          gap: "1rem",
        },
      },
    }).mount();
  }

  if (document.querySelector("#projects-slider")) {
    new Splide("#projects-slider", {
      type: "loop",
      autoplay: true,
      focus: "center",
      perPage: 7,
      perMove: 1,
      autoWidth: true,
      height: "60px",
      pagination: false,
      arrows: false,
      breakpoints: {
        1440: {
          perPage: 7,
          gap: "1rem",
        },
        1220: {
          perPage: 6,
          gap: "1rem",
        },
        1024: {
          perPage: 5,
          gap: "1rem",
        },
        640: {
          perPage: 4,
          gap: "1rem",
        },
        480: {
          perPage: 3,
          gap: "1rem",
        },
      },
    }).mount();
  }

  const lightbox = GLightbox({
    touchNavigation: true,
    loop: true,
    autoplayVideos: true,
    selector:
      ".wp-block-gallery:not(.no-lightbox) a, .wp-block-image:not(.no-lightbox) a, .wp-block-image:not(.no-lightbox) a",
  });
});
